





















































































import Vue from 'vue'
import credits from './credits.json'
import DevBadge from './SupporterBadges/Dev.vue'
import TierFive from './SupporterBadges/TierFive.vue'
import TierFour from './SupporterBadges/TierFour.vue'
import TierThree from './SupporterBadges/TierThree.vue'
import TierTwo from './SupporterBadges/TierTwo.vue'
import TierOne from './SupporterBadges/TierOne.vue'
import SpecialThanks from './SupporterBadges/SpecialThanks.vue'
import gistApi from '@/io/apis/gist'

export default Vue.extend({
  name: 'about',
  components: { DevBadge, TierFive, TierFour, TierThree, TierTwo, TierOne, SpecialThanks },
  data: () => ({
    commitRef: 'UNKNOWN',
    credits: credits,
    loading: true,
  }),
  created() {
    gistApi
      .getCredits()
      .then((response: any) => {
        if (!response || !response.files) {
          this.credits = credits
        } else {
          this.credits = JSON.parse(response.files['credits.json'].content)
        }
        this.loading = false
      })
      .catch(() => {
        this.credits = credits
        this.loading = false
      })
  },
  mounted() {
    this.commitRef = process.env.COMMIT_REF
  },
})
